import React, { useEffect } from "react";
import {
  HOSPITAL_ADDRESS,
  HOSPITAL_NAME,
  HOSPITAL_PHONE,
  LOGO_URL,
} from "../../../../config";

const EmployeeEvaluationPrint = ({ leaves }) => {
  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
    }).format(new Date(date));
  };

  useEffect(() => {
    const printStyles = `
      @media print {
        @page {
          size: A4;
          margin: 20mm;
        }
        body {
          font-family: 'Roboto', sans-serif;
          margin: 0;
          padding: 0;
          color: #000;
        }
        .print-container {
          padding-top: 120px;
          padding-bottom: 50px;
          background-color: white;
        }
        .evaluation-entry {
          page-break-inside: avoid;
          margin-bottom: 30px;
          border-bottom: 2px solid #ddd;
          padding-bottom: 20px;
        }
        .evaluation-entry h3 {
          margin: 0;
          font-size: 18px;
          color: #333;
          font-weight: bold;
        }
        .evaluation-entry p {
          margin: 5px 0;
          font-size: 14px;
        }
      }
    `;
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = printStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  if (!leaves || leaves.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          fontFamily: "'Roboto', sans-serif",
        }}
      >
        <h3>No Evaluation Records Found</h3>
      </div>
    );
  }

  return (
    <div
      className="print-container"
      style={{
        fontFamily: "'Roboto', sans-serif",
        backgroundColor: "#fff",
        color: "#333",
        lineHeight: "1.5",
        fontSize: "14px",
        margin: "20px",
      }}
    >
      {/* Header Section */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingBottom: "10px",
          marginBottom: "15px",
          borderBottom: "2px solid #000",
        }}
      >
        <div style={{ textAlign: "left" }}>
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              margin: 0,
              color: "#000",
            }}
          >
            {HOSPITAL_NAME}
          </h1>
          <p
            style={{
              fontSize: "14px",
              margin: "5px 0",
              color: "#E91E63",
              fontWeight: "600",
            }}
          >
            EMPLOYEE EVALUATION REPORT
          </p>
        </div>
        <div style={{ textAlign: "center" }}>
          <img
            src={LOGO_URL}
            alt="Clinic Logo"
            style={{ width: "80px", height: "auto", marginBottom: "5px" }}
          />
        </div>
        <div style={{ textAlign: "right", direction: "rtl" }}>
          <h2
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              margin: 0,
              color: "#E91E63",
            }}
          >
            {HOSPITAL_NAME}
          </h2>
          <p
            style={{
              fontSize: "14px",
              margin: "5px 0",
              color: "#333",
            }}
          >
            گزارش ارزیابی کارکنان
          </p>
        </div>
      </header>

      {/* Evaluation Entries Section */}
      <section>
        {leaves.map((leave) => (
          <div
            key={leave.id}
            className="evaluation-entry"
            style={{
              borderBottom: "2px solid #ddd",
              marginBottom: "30px",
              paddingBottom: "20px",
            }}
          >
            <h3 style={{ marginBottom: "10px" }}>{leave.employee_display}</h3>
            <p>
              <strong>Month:</strong> {leave.month_display}
            </p>
            <p>
              <strong>Year:</strong> {leave.year}
            </p>
            <p>
              <strong>Rate:</strong> {leave.rate || "N/A"}
            </p>
            <p>
              <strong>Description:</strong>{" "}
              {leave.description || "No description available"}
            </p>
            <p>
              <strong>Date Created:</strong> {formatDate(leave.created_at)}
            </p>
          </div>
        ))}
      </section>

      {/* Footer Section */}
      <footer
        style={{
          position: "absolute",
          bottom: "20px",
          left: "20px",
          right: "20px",
          textAlign: "center",
          fontSize: "12px",
          color: "#666",
          borderTop: "2px solid #000",
          paddingTop: "10px",
        }}
      >
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: "15px 20px",
            borderTop: "3px solid #000",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📞 {HOSPITAL_PHONE}
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📞 {HOSPITAL_PHONE}
            </p>
          </div>
          <div style={{ textAlign: "center" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              {HOSPITAL_ADDRESS}
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              {/* 🌐 www.turkishclinic.af */}
            </p>
          </div>
          <div style={{ textAlign: "right" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📱 {HOSPITAL_PHONE}
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📱 {HOSPITAL_PHONE}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default EmployeeEvaluationPrint;
